module.exports = __webpack_public_path__ + "static/media/ic_baseline-location-on.592b185d.svg";